module.exports = __webpack_public_path__ + "img/book3-active.6742b411.png";